import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=7f210449&scoped=true"
import script from "./SaveButton.vue?vue&type=script&lang=js"
export * from "./SaveButton.vue?vue&type=script&lang=js"
import style0 from "./SaveButton.vue?vue&type=style&index=0&id=7f210449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f210449",
  null
  
)

export default component.exports